import { useNavigate, useSearchParams } from 'react-router-dom';
import { ServerErrorPage, ServerErrorType } from '@azyntor-labs/nexus-ui';
import { useExamAuth } from '@/hooks/useExamAuth';

export const ServerError = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { hasAnyRole, user } = useExamAuth();

  // Get error type from URL params (default to 500)
  const errorCode = searchParams.get('code') as ServerErrorType || '500';
  const errorId = searchParams.get('errorId') || undefined;

  const getDashboardPath = () => {
    if (!user) return '/login';
    if (hasAnyRole(['system_admin', 'super_admin', 'admin'])) return '/admin/dashboard';
    if (hasAnyRole(['instructor', 'teacher'])) return '/teacher/dashboard';
    if (hasAnyRole(['proctor'])) return '/proctoring/monitor';
    return '/student/dashboard';
  };

  return (
    <ServerErrorPage
      errorType={errorCode}
      errorId={errorId}
      onGoHome={() => navigate(getDashboardPath())}
      onRetry={() => window.location.reload()}
      homeLabel="Go to Dashboard"
      retryLabel="Try Again"
    />
  );
};

export default ServerError;
